import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Privacy = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col lg={8} className="mx-auto">
          <h1 className="mb-4">Privacy Policy</h1>
          <p className="text-muted mb-5">
            Last updated: {new Date().getFullYear()}
          </p>

          <div className="mt-4">
            <h3>1. Information We Collect</h3>
            <p>
              We collect information necessary to provide institutional-grade
              services, including identity verification, compliance
              documentation, and transaction data.
            </p>
          </div>

          <div className="mt-4">
            <h3>2. How We Use Your Information</h3>
            <p>
              Your information is used to provide services, ensure regulatory
              compliance, prevent fraud, and improve our platform security and
              functionality.
            </p>
          </div>

          <div className="mt-4">
            <h3>3. Data Protection</h3>
            <p>
              We implement robust security measures to protect your data,
              including encryption, access controls, and regular security
              audits.
            </p>
          </div>

          <div className="mt-4">
            <h3>4. GDPR Compliance</h3>
            <p>
              We are fully compliant with GDPR and other applicable data
              protection regulations. You have rights regarding your personal
              data.
            </p>
          </div>

          <div className="mt-4">
            <h3>5. Data Sharing</h3>
            <p>
              We only share data as required for regulatory compliance, with
              your explicit consent, or as necessary to provide our services.
            </p>
          </div>

          <div className="mt-5">
            <p className="text-muted">
              For questions about our privacy practices, contact
              privacy@airclift.com
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Privacy;
